import React, { useEffect } from 'react';
import Table from '@material-ui/core/Table';
import { useDispatch, useSelector } from 'react-redux';
import TableBody from '@material-ui/core/TableBody';
import PayeoffCell from './PayeoffCell';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import ListHeader from 'routes/Pages/FinanceManagment/PayeoffList/ListTableView/ListHeader';
import { getFinaceList } from '../../../../../redux/actions/Finance';

const ListTableView = () => {
  const dispatch = useDispatch();
  const { shortFinanceList } = useSelector(({ finance }) => finance);

  useEffect(() => {
    dispatch(getFinaceList());
  }, [dispatch]);

  return (
    <React.Fragment>
      <Box className="Cmt-table-responsive">
        <Table>
          <ListHeader />
          <TableBody>
            {shortFinanceList.map(finance => (
              <PayeoffCell key={finance.id} finance={finance} />
            ))}
          </TableBody>
        </Table>
      </Box>
    </React.Fragment>
  );
};

export default ListTableView;

ListTableView.prototype = {
  checkedContacts: PropTypes.array,
  handleCellCheckBox: PropTypes.func,
  handleHeaderCheckBox: PropTypes.func,
  updateCheckedContacts: PropTypes.func,
  onShowContactDetail: PropTypes.func,
};

ListTableView.defaultProps = {
  checkedContacts: [],
};
